import React from 'react'
import { useNavigate } from 'react-router'

import PageActions, { PageAction } from '@/components/utils/PageActions'
import { useCompanyProfileSearchParams } from '@/hooks/useCompanyProfileSearchParams'
import { useIsRoute } from '@/hooks/useIsRoute'
import { ROUTES } from '@/lib/routes'

const DevActions: React.FC = () => {
  const isRoute = useIsRoute()
  const actions: PageAction[] = []
  const navigate = useNavigate()
  const { searchParams } = useCompanyProfileSearchParams()

  if (isRoute(ROUTES._companyProfile)) {
    actions.push({
      label: 'View profile modal',
      action: () => {
        navigate(
          ROUTES.professionalNetworkRelationships({
            searchParams: {
              identifier: searchParams.identifier,
              identifierType: searchParams.identifierType,
            },
          }),
        )
      },
    })
  }

  if (!isRoute(ROUTES._companyProfile)) {
    actions.push({
      label: 'View profile page',
      action: () => {
        navigate(
          ROUTES.companyProfile({
            searchParams: {
              identifier: searchParams.identifier,
              identifierType: searchParams.identifierType,
            },
          }),
        )
      },
    })
  }

  return <PageActions actions={actions} />
}

export default DevActions
